<template>
  <div class="brand-selector">
    <SelectV02
      attach
      class="brand-selector__select"
      deletable-chips
      dense
      eager
      isSearchable
      item-text="key"
      open-on-clear
      outlined
      return-object
      @blur="saveToStore"
      @input="handleInputChange"
      :categoryText="categoryKey"
      :chips="isMultiselect"
      :clearable="isMultiselect"
      :displayLimit="isMultiselect ? 2 : null"
      :items="activeViewEnabledBrands"
      :key="activeView"
      :label="label"
      :menu-props="menuProps"
      :multiple="isMultiselect"
      :shouldSortValues="true"
      :showSelectAll="isMultiselect"
      :value="selectedBrandsToDisplay"
    />
  </div>
</template>
<script>
import { isEqual } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { SelectV02 } from '@mikmak/components';
import {
  getSelectedPortfolioBrands,
} from '../../services/dashboard/portfolioBrandsService';

export default {
  components: {
    SelectV02,
  },
  data() {
    return {
      selectedBrandsLocal: [],
    };
  },
  mounted() {
    this.selectedBrandsLocal = this.selectedBrands;
  },
  computed: {
    ...mapState({
      activeView: state => state.main.activeView,
      portfolioBrands: state => state.dashboard.portfolioBrands,
    }),
    ...mapGetters([
      'activeViewEnabledBrands',
      'selectedBrands',
      'selectedBrandIds',
    ]),
    categoryKey() {
      return this.isMultiselect ? 'portfolioName' : '';
    },
    isMultiselect() {
      return this.activeView !== 'Benchmarks';
    },
    label() {
      return this.isMultiselect ? 'Select Brands' : 'Select Brand';
    },
    menuProps() {
      return {
        allowOverflow: true,
        bottom: true,
        closeOnClick: true,
        dense: true,
        offsetY: true,
        rounded: true,
      };
    },
    selectedBrandIdsLocal() {
      return this.selectedBrandsLocal.map(brand => brand.brandId);
    },
    selectedBrandsToDisplay() {
      if (this.isMultiselect || this.selectedBrandsLocal.length > 1) {
        return this.selectedBrandsLocal;
      }

      return this.selectedBrandsLocal[0];
    },
    selectionsHaveChanged() {
      if (this.selectedBrandIdsLocal.length !== this.selectedBrandIds.length) {
        return true;
      }

      return !isEqual(this.selectedBrandIdsLocal, this.selectedBrandIds);
    },
  },
  methods: {
    handleInputChange(newInput) {
      if (this.isMultiselect) {
        this.selectedBrandsLocal = newInput;
      } else {
        this.selectedBrandsLocal = [newInput];
        this.saveToStore();
      }
    },
    async saveToStore() {
      if (this.selectionsHaveChanged) {
        const updatedPortfolioBrands = getSelectedPortfolioBrands(
          this.portfolioBrands,
          this.selectedBrandIdsLocal,
        );

        await this.$store.dispatch('setPortfolioBrands', updatedPortfolioBrands);
      }
    },
  },
  watch: {
    selectedBrands(brands) {
      this.selectedBrandsLocal = brands;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep #app {
  overflow: visible;
}

.brand-selector {
  width: 330px;
  height: 100%;
  padding-left: 16px;
}

.brand-selector__select {
  display: inline;
}

::v-deep .v-input__slot > .v-label.theme--light {
  position: initial !important;
}
</style>
